class pageNavigation {

    constructor() {
        this.$container = $('#pageNavigation');
        this.$subNavigation = $('#subNavigation');
        this.$subs = this.$container.find('li');

        this.createOverlay();
        this.openControl();
    }

    // events
    openControl() {
        let that = this;

        var hoverTimeout;
        that.$subs.hover(function () { //hover
            if (!$('.pageSearch').hasClass('isActive') && !$('.pageShare').hasClass('isActive') && !$('.profileNavigation').hasClass('isActive')) { //show only if page search and page search is not active
                if ($(this).hasClass('hasSub')) { //if item has subMenu show navigation
                    if (!that.$container.hasClass('active')) { //if navigation is not open set timer to delay and try open
                        clearTimeout(hoverTimeout);
                        var $this = $(this);
                        hoverTimeout = setTimeout(function () {
                            that.showSubNav($this);
                        }, 300);
                    } else { //if navigation is open change submenu
                        that.showSubNav($(this));
                    }
                } else { //if item has not submenu hide navigation
                    that.hideSubNav();
                }
            }
        }, function () {
            if ($(this).hasClass('hasSub')) { //if item has subMenu
                if (!that.$container.hasClass('active')) { //if navigation is not open but hover is out clear timer to disable navigation to open
                    clearTimeout(hoverTimeout);
                }
            }
        });

        // hide navigation on hover on nav overlay
        that.$overlay.hover(function () {
            if (that.$container.hasClass('active')) {
                that.hideSubNav();
            }
        });
    }

    // show navigation or change sub navigation
    showSubNav($obj) {
        let that = this;

        if (!that.$container.hasClass('active')) { // show navigation
            that.$container.addClass('active');
            that.$subNavigation.show();
            that.showNavOverlay();
            hideShare();
        } else {
            $('.hasSub').removeClass('active'); // hide last active sub navigation
        }

        // open new sub navigation
        $obj.addClass('active');
        let target = $obj.attr('data-subNav');
        $(target).show().siblings().hide();
        profileNav.close();
    }

    // hide navigation
    hideSubNav() {
        let that = this;
        $('.hasSub').removeClass('active');
        that.$container.removeClass('active');
        that.$subNavigation.hide();
        that.hideNavOverlay();
    }

    // add nav overlay to page
    createOverlay() {
        let $elm = $('<div>');
        $elm
            .addClass('subNavigation__overlay')
            .attr('id', 'subNavigation__overlay');

        $('body').append($elm);
        this.$overlay = $elm;
    }

    showNavOverlay() {
        this.$overlay.stop().fadeIn(250);
    }

    hideNavOverlay() {
        this.$overlay.stop().fadeOut(250);
    }
}

let pageNav = new pageNavigation();